export * from './ng-zorro-module/index';
export * from './icons-provider.module';
